import { Font } from "@react-pdf/renderer";
import DancingScriptFont from "../../../../assets/font/DancingScript-Variable.ttf"
import AlluraFont from "../../../../assets/font/Allura-Regular.ttf"
import SacrificeFont from "../../../../assets/font/SacrificeDemo.ttf"
import LosevkaFont from "../../../../assets/font/IosevkaCharon-Regular.ttf"
import IBMPlexFont from "../../../../assets/font/IBMPlexMono-Regular.ttf"

Font.register({
  family: "Signature",
  src: DancingScriptFont
});

Font.register({
    family:"Allura",
    src: AlluraFont
});

Font.register({
    family:"Sacrifice",
    src: SacrificeFont
});

Font.register({
    family:"losevka",
    src: LosevkaFont
});

Font.register({
    family:"IBMPlex",
    src: IBMPlexFont
});